module.exports = __webpack_public_path__ + "static/media/AvenirNext-Italic.06fc0b69.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Italic.eot?#iefix
// module id = 75
// module chunks = 0